module.exports = __webpack_public_path__ + "img/dp-xx-ba1.136ea58b.png";